import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	wrap: {
		display: "inline-flex",
		alignItems: "center",
		gap: 7,
	},
	dot: {
		width: 8,
		height: 8,
		borderRadius: "50%",
		flexShrink: 0,
	},
	online: {
		backgroundColor: theme.palette.success.main,
		// O halo pulsante e o que faz "online" ser lido de relance, sem
		// precisar comparar cores.
		animation: "$pulse 2s ease-in-out infinite",
	},
	offline: {
		backgroundColor: theme.palette.type === "dark" ? "#475569" : "#CBD5E1",
	},
	blocked: {
		backgroundColor: theme.palette.error.main,
	},
	label: {
		fontSize: "0.78rem",
		fontWeight: 600,
		lineHeight: 1,
	},
	labelOnline: { color: theme.palette.success.main },
	labelOffline: { color: theme.custom.textSecondary },
	labelBlocked: { color: theme.palette.error.main },
	"@keyframes pulse": {
		"0%": { boxShadow: "0 0 0 0 rgba(16,185,129,0.55)" },
		"70%": { boxShadow: "0 0 0 6px rgba(16,185,129,0)" },
		"100%": { boxShadow: "0 0 0 0 rgba(16,185,129,0)" },
	},
}));

const StatusDot = ({ state, label }) => {
	const classes = useStyles();

	const dotClass =
		state === "blocked"
			? classes.blocked
			: state === "online"
			? classes.online
			: classes.offline;

	const labelClass =
		state === "blocked"
			? classes.labelBlocked
			: state === "online"
			? classes.labelOnline
			: classes.labelOffline;

	return (
		<span className={classes.wrap}>
			<span className={`${classes.dot} ${dotClass}`} />
			{label && <span className={`${classes.label} ${labelClass}`}>{label}</span>}
		</span>
	);
};

export default StatusDot;
